module.exports = __webpack_public_path__ + "static/media/ucon7.aa3f4e05.JPG";